import Vue from 'vue';
import toast from './toast.vue';
//创建构造器 将组件放进去
const ToastConstructor =  Vue.extend(toast);
//定一个触发toast显示的方法 并且写好显示的规则、参数等
function showToast(text,duration=2200){
	const toastDOM = new ToastConstructor({
		el:document.createElement('div'),
		data(){
			return{
				text:text
			};
		}
	});
	//添加到body中
	document.body.appendChild(toastDOM.$el);
	//自动消失
	setTimeout(()=>{
		let dom = toastDOM.$el;
		dom.parentNode.removeChild(dom);
	},duration);
};
//按照vue规则，定义全局方法需要暴露一个 install 方法，如default导出为方法则可当做install使用 因此这样写
function toastRegistry(){
	Vue.prototype.$toast = showToast;
};
export default toastRegistry;
